export default __webpack_public_path__ + "static/media/Paladin's Siege Shield.1d2f3ab9.jpg";